
// import React, { useState, useRef, useEffect } from 'react';

// const ShareButton = ({ brandName = 'Brand Audit' }) => {
//   const [open, setOpen] = useState(false);
//   const menuRef = useRef(null);

//   // Close on outside click
//   useEffect(() => {
//     const handler = (e) => {
//       if (menuRef.current && !menuRef.current.contains(e.target)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   // Download as PDF (uses browser print)
//   const handleDownloadPDF = () => {
//     setOpen(false);
//     const originalTitle = document.title;
//     const safe = brandName.replace(/[^a-z0-9]/gi, '_').substring(0, 30);
//     const date = new Date().toLocaleDateString('en-CA');
//     document.title = `${safe}_BrandAudit_${date}`;

//     setTimeout(() => {
//       window.print();
//       setTimeout(() => { document.title = originalTitle; }, 1500);
//     }, 80);
//   };

//   // Only one menu item – PDF
//   const menuItems = [
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor">
//           <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4l4-4h5l4-4V8zm-3-6H8C6.34 2 5 3.34 5 5v1h14V5c0-1.66-1.34-3-3-3z"/>
//         </svg>
//       ),
//       label: 'Download PDF',
//       action: handleDownloadPDF,
//       color: '#6B4FA0',
//     },
//   ];

//   return (
//     <div
//       ref={menuRef}
//       className="share-fab"
//       style={{
//         position: 'fixed',
//         bottom: 28,
//         right: 20,
//         zIndex: 9000,
//       }}
//     >
//       {/* Menu – only shown when open */}
//       {open && (
//         <div style={{
//           position: 'absolute',
//           bottom: 60,
//           right: 0,
//           background: 'rgba(255,255,255,0.96)',
//           border: '1px solid rgba(107,79,160,0.18)',
//           borderRadius: 14,
//           boxShadow: '0 8px 32px rgba(107,79,160,0.18)',
//           backdropFilter: 'blur(16px)',
//           WebkitBackdropFilter: 'blur(16px)',
//           overflow: 'hidden',
//           minWidth: 176,
//           animation: 'menuPop 0.2s cubic-bezier(0.34,1.56,0.64,1)',
//         }}>
//           <style>{`
//             @keyframes menuPop {
//               from { opacity: 0; transform: scale(0.92) translateY(8px); }
//               to   { opacity: 1; transform: scale(1) translateY(0); }
//             }
//           `}</style>

//           {/* Optional header – you can keep or remove */}
//           <div style={{
//             padding: '10px 14px 8px',
//             fontSize: 10,
//             fontWeight: 700,
//             letterSpacing: '0.08em',
//             textTransform: 'uppercase',
//             color: '#8B82A0',
//             borderBottom: '1px solid rgba(107,79,160,0.08)',
//           }}>
//             Export report
//           </div>

//           {/* Only PDF item */}
//           {menuItems.map((item, i) => (
//             <button
//               key={i}
//               onClick={item.action}
//               style={{
//                 width: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 10,
//                 padding: '11px 14px',
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 fontFamily: "'DM Sans', sans-serif",
//                 fontSize: 13,
//                 fontWeight: 500,
//                 color: item.color,
//                 textAlign: 'left',
//                 transition: 'background 0.12s',
//               }}
//               onMouseEnter={e => e.currentTarget.style.background = 'rgba(107,79,160,0.06)'}
//               onMouseLeave={e => e.currentTarget.style.background = 'none'}
//             >
//               <span style={{ flexShrink: 0, color: item.color }}>{item.icon}</span>
//               {item.label}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* Floating action button */}
//       <button
//         onClick={() => setOpen(prev => !prev)}
//         title="Download PDF report"
//         style={{
//           width: 48,
//           height: 48,
//           borderRadius: '50%',
//           background: open ? '#5A3D8A' : '#6B4FA0',
//           border: 'none',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           boxShadow: '0 4px 20px rgba(107,79,160,0.4)',
//           transition: 'all 0.2s',
//           transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
//         }}
//       >
//         {open ? (
//           // × when open
//           <svg viewBox="0 0 24 24" width="20" height="20" fill="white">
//             <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
//           </svg>
//         ) : (
//           // PDF icon when closed (more appropriate than share icon)
//           <svg viewBox="0 0 24 24" width="20" height="20" fill="white">
//             <path d="M20 8h-2v5h2V8zm0-2h-2V4h2v2zm-4-2v2h-2V4h2zm-2 16h-2v-2h2v2zm4 0h-2v-2h2v2zm2-4h-2v-2h2v2zm-8-2H6v-3h2v3h2v-5h2v8zm-4 6H4v-2h2v2zm-2 0H2v-2h2v2zm14 0h-2v-2h2v2zm-4-2h-2v-2h2v2z"/>
//           </svg>
//         )}
//       </button>
//     </div>
//   );
// };

// export default ShareButton;

// src/components/BrandAudit/ShareButton.jsx
import React, { useState, useRef, useEffect } from 'react';
import { shareAPI } from '../../services/api';

// ─────────────────────────────────────────────────────────────────────────────
// Snapshot helpers
// ─────────────────────────────────────────────────────────────────────────────
const SHARE_KEY_PREFIXES = [
  'auditFormData',
  'lastAuditInfo',
  'competitors_list',
  'competitors_brand',
  'overallScore_',
  'domainAuthority_',
  'pageSpeedRaw_',
  'technicalSEO_',
  'gmbBrand_',
  'gmbRanking_',
  'aiVisibility_',
  'final_verdict_',
  'ai_insight_',
];

const collectAuditSnapshot = () => {
  const snapshot = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;
    if (SHARE_KEY_PREFIXES.some(p => key.startsWith(p))) {
      try { snapshot[key] = JSON.parse(localStorage.getItem(key)); }
      catch { snapshot[key] = localStorage.getItem(key); }
    }
  }
  return snapshot;
};

// Called by PublicAuditView to restore snapshot into localStorage
export const restoreAuditSnapshot = (snapshot) => {
  Object.entries(snapshot).forEach(([key, value]) => {
    try {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    } catch {}
  });
};

// ─────────────────────────────────────────────────────────────────────────────
// ShareButton
// ─────────────────────────────────────────────────────────────────────────────
const ShareButton = ({ brandName = 'Brand Audit' }) => {
  const [open,    setOpen]    = useState(false);
  const [copied,  setCopied]  = useState(false);
  const [sharing, setSharing] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // ✅ Fix
const generateShareUrl = async () => {
  const snapshot = collectAuditSnapshot();
  const auditId  = `audit_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

  await shareAPI.saveSnapshot(auditId, snapshot);  // ← uses publicApi
  return `${window.location.origin}/audit/view/${auditId}`;
};


  //   const auditId  = `audit_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
  //   localStorage.setItem(
  //     `shared_audit_${auditId}`,
  //     JSON.stringify({ ts: Date.now(), data: snapshot })
  //   );
  //   // Public route — must be outside auth guard in your router
  //   return `${window.location.origin}/audit/view/${auditId}`;
  // };

  const handleCopyLink = async () => {
  if (sharing) return;
  setSharing(true);
  try {
    const url = await generateShareUrl();
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => { setCopied(false); setOpen(false); }, 2200);
  } catch (e) {
    console.error('Copy link failed:', e);
  } finally {
    setSharing(false);
  }
};

const handleWhatsApp = async () => {   // ← async added
  if (sharing) return;
  setOpen(false);
  setSharing(true);
  try {
    const url = await generateShareUrl();
    const text = encodeURIComponent(
      `Hi! Here's the Brand Audit report for *${brandName}*:\n\n${url}`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
  } catch (e) {
    console.error('WhatsApp share failed:', e);
  } finally {
    setSharing(false);
  }
};

  // ── 1. Download PDF ────────────────────────────────────────────────────────
  const handleDownloadPDF = () => {
    setOpen(false);
    const orig = document.title;
    const safe = brandName.replace(/[^a-z0-9]/gi, '_').substring(0, 30);
    document.title = `${safe}_BrandAudit_${new Date().toLocaleDateString('en-CA')}`;
    setTimeout(() => {
      window.print();
      setTimeout(() => { document.title = orig; }, 1500);
    }, 80);
  };

  // ── 2. Copy shareable link ─────────────────────────────────────────────────
  // const handleCopyLink = async () => {
  //   if (sharing) return;
  //   setSharing(true);
  //   try {
  //     const url = generateShareUrl();
  //     try {
  //       await navigator.clipboard.writeText(url);
  //     } catch {
  //       const ta = document.createElement('textarea');
  //       ta.value = url;
  //       ta.style.cssText = 'position:fixed;opacity:0';
  //       document.body.appendChild(ta);
  //       ta.select();
  //       document.execCommand('copy');
  //       document.body.removeChild(ta);
  //     }
  //     setCopied(true);
  //     setTimeout(() => { setCopied(false); setOpen(false); }, 2200);
  //   } catch (e) {
  //     console.error('Copy link failed:', e);
  //   } finally {
  //     setSharing(false);
  //   }
  // };

  // ── 3. WhatsApp — single message, no duplication ──────────────────────────
  // const handleWhatsApp = () => {
  //   if (sharing) return;
  //   setOpen(false);
  //   setSharing(true);
  //   try {
  //     const url = generateShareUrl();
  //     // One clean message — encodeURIComponent handles special chars
  //     const text = encodeURIComponent(
  //       `Hi! Here's the Brand Audit report for *${brandName}*:\n\n${url}`
  //     );
  //     window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
  //   } catch (e) {
  //     console.error('WhatsApp share failed:', e);
  //   } finally {
  //     setSharing(false);
  //   }
  // };

  const menuItems = [
    {
      label:  'Download PDF',
      action: handleDownloadPDF,
      color:  '#6B4FA0',
      icon: (
        <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor">
          <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4l4-4h5l4-4V8zm-3-6H8C6.34 2 5 3.34 5 5v1h14V5c0-1.66-1.34-3-3-3z"/>
        </svg>
      ),
    },
    {
      label:    copied ? '✓ Link copied!' : sharing ? 'Generating…' : 'Copy share link',
      action:   handleCopyLink,
      color:    copied ? '#0D9488' : '#6B4FA0',
      disabled: sharing,
      icon: sharing ? (
        <div style={{
          width: 15, height: 15,
          border: '2px solid #6B4FA0', borderTopColor: 'transparent',
          borderRadius: '50%', animation: 'spinFab 0.7s linear infinite',
        }} />
      ) : (
        <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor">
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
        </svg>
      ),
    },
    {
      label:    'Share on WhatsApp',
      action:   handleWhatsApp,
      color:    '#25D366',
      disabled: sharing,
      icon: (
        <svg viewBox="0 0 24 24" width="15" height="15" fill="#25D366">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      ),
    },
  ];

  return (
    <>
      <style>{`
        @keyframes menuPop {
          from { opacity:0; transform:scale(0.92) translateY(8px); }
          to   { opacity:1; transform:scale(1)    translateY(0);   }
        }
        @keyframes spinFab { to { transform: rotate(360deg); } }
      `}</style>

      <div ref={menuRef} className="share-fab" style={{ position:'fixed', bottom:28, right:20, zIndex:9000 }}>

        {/* Dropdown */}
        {open && (
          <div style={{
            position:'absolute', bottom:60, right:0,
            background:'rgba(255,255,255,0.97)',
            border:'1px solid rgba(107,79,160,0.18)',
            borderRadius:14,
            boxShadow:'0 8px 32px rgba(107,79,160,0.2)',
            backdropFilter:'blur(16px)', WebkitBackdropFilter:'blur(16px)',
            overflow:'hidden', minWidth:210,
            animation:'menuPop 0.2s cubic-bezier(0.34,1.56,0.64,1)',
          }}>
            <div style={{
              padding:'10px 14px 8px', fontSize:10, fontWeight:700,
              letterSpacing:'0.08em', textTransform:'uppercase',
              color:'#8B82A0', borderBottom:'1px solid rgba(107,79,160,0.08)',
            }}>
              Share report
            </div>

            {menuItems.map((item, i) => (
              <button
                key={i}
                onClick={item.disabled ? undefined : item.action}
                disabled={!!item.disabled}
                style={{
                  width:'100%', display:'flex', alignItems:'center', gap:10,
                  padding:'11px 14px', background:'none', border:'none',
                  cursor: item.disabled ? 'not-allowed' : 'pointer',
                  fontFamily:"'DM Sans',sans-serif", fontSize:13, fontWeight:500,
                  color: item.disabled ? '#C4BDD6' : item.color,
                  textAlign:'left', opacity: item.disabled ? 0.6 : 1,
                  borderBottom: i < menuItems.length - 1
                    ? '1px solid rgba(107,79,160,0.06)' : 'none',
                  transition:'background 0.12s',
                }}
                onMouseEnter={e => { if (!item.disabled) e.currentTarget.style.background='rgba(107,79,160,0.06)'; }}
                onMouseLeave={e => { e.currentTarget.style.background='none'; }}
              >
                <span style={{ flexShrink:0 }}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        )}

        {/* FAB */}
        <button
          onClick={() => setOpen(p => !p)}
          title="Share or download report"
          style={{
            width:48, height:48, borderRadius:'50%',
            background: open ? '#5A3D8A' : '#6B4FA0',
            border:'none', cursor:'pointer',
            display:'flex', alignItems:'center', justifyContent:'center',
            boxShadow:'0 4px 20px rgba(107,79,160,0.4)',
            transition:'all 0.2s',
            transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
          }}
        >
          {open ? (
            <svg viewBox="0 0 24 24" width="20" height="20" fill="white">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="20" height="20" fill="white">
              <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
            </svg>
          )}
        </button>
      </div>
    </>
  );
};

export default ShareButton;
